import { Reveal } from "@/components/site/Reveal";

export const Problem = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative scroll-mt-24 bg-white py-24 sm:py-36"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs font-semibold uppercase tracking-[0.3em] text-brand-600">
              · ΤΟ ΠΡΟΒΛΗΜΑ
            </span>
            <p className="mt-6 text-sm leading-relaxed text-muted-foreground">
              Flyers, διαφημίσεις, newsletters… καταλήγουν γρήγορα στον κάδο.
              Γιατί; Επειδή τίποτα δεν ξεχωρίζει πραγματικά.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.05}>
            <h2 className="font-display text-3xl font-bold leading-[1.08] text-ink sm:text-5xl">
              Πόσο δύσκολο είναι σήμερα να κερδίσεις την{" "}
              <span className="text-brand-500">προσοχή</span> του κοινού σου;
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-ink/70 sm:text-xl">
              Ο μέσος άνθρωπος βλέπει χιλιάδες μηνύματα κάθε μέρα και τα
              περισσότερα τα αγνοεί.
            </p>
          </Reveal>

          <Reveal delay={0.18}>
            <p className="mt-10 font-display text-2xl font-semibold text-ink sm:text-3xl">
              Ή μήπως όχι;
            </p>
          </Reveal>

          <Reveal delay={0.24}>
            <div className="mt-8 max-w-2xl border-l-2 border-brand-500 pl-6">
              <p className="text-lg leading-relaxed text-ink/80 sm:text-xl">
                Με την <span className="font-semibold text-brand-600">VideoActive</span>,
                η ιστορία του brand σου παίζει από μόνη της, τη στιγμή που ο
                παραλήπτης ανοίγει το έντυπο. Είναι ο πιο άμεσος τρόπος για να
                μείνει το brand σου…{" "}
                <span className="font-display font-bold text-ink">Αξέχαστο!</span>
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
